import UtilityService from '../services/utility.service';
import DataService from '../services/data.service';
import ModalCloseComponent from './modal-close.component';

export class LoginFormComponent {
    constructor() {
        this.componentName = "loginFormComponent";
	    this.template = `
		<div id="loginForm">
		<h1>ChemDrill Login</h1>
			<div class="form-group col-md-3 mx-auto">
			  <button id="submitButton" onClick="window.location.href='https://auth.nard.dev/?login=3'" class="btn btn-sm btn-primary">Login with Google</button>
			</div>
		</div>
	    `;

    }

    render(){
		_svc.util.html("#"+this.componentName, this.template);
		_svc.util.clear("#navBarComponent");
	}
	
	authenticate () {
		var userId = _svc.util.element("userId").value;
		var pwd = _svc.util.element("pwd").value;
		
		if (userId.length == 0 || pwd.length == 0 ) { 
			_cmp.modalClose.render("Error", "User ID and Password must not be blank.");
			console.log("User ID or Password is blank.");
			return; 
		}
		
		_svc.data.authenticate({userId: userId, pwd: pwd}, _cmp.loginForm.postSuccess, _cmp.loginForm.postFailed);
	}
	
	postSuccess(res) {
		_cmp.loginForm.init(res);
	}
	
	postFailed(err) {
		localStorage.clear();
		$("#pwd").val("");
		console.log(err);
		_cmp.modalClose.render("Error", "Invalid User ID or Password.");
	}
	
	init(res) {
		localStorage.setItem("token", res.token);
		_svc.util.clear("#" + this.componentName);
		_cmp.main.render();
	}
	

	handleKeyEvent(e) {
		if (e.keyCode === 13) {
			e.preventDefault();
			_cmp.loginForm.authenticate()
		}
	}
};

setTimeout(function(){_cmp.loginForm = new LoginFormComponent()},1);
